<div class="">
  <div *ngIf="editMode">
    <button type="button" nbButton size="small" status="warning" (click)="switchMode()" class="mr-2">Switch to {{isStructuredBlock ? 'simple text' : 'block mode'}}</button>
    <!--<button type="button" nbButton size="small" status="success" (click)="save()" class="mr-2" *ngIf="isStructuredBlock">Save</button>-->
    <!--<button type="button" nbButton size="small" status="success" (click)="rollback()">Rollback</button>-->
    <button type="button" nbButton size="small" status="danger" (click)="updateFieldFromTemplate()" *ngIf="changeCount>0 && templateModel">Update from template</button>
    <button nbButton size="small" 
        [nbContextMenu]="applyMenu" [nbContextMenuTag]="'multilang-editor'+attribute" *ngIf="showApplyChanges && !game?.id">
      <nb-icon icon="code-download-outline" pack="eva"></nb-icon>&nbsp;Apply field changes
    </button>
  </div>

  <div *ngIf="isStructuredBlock">
    
    <div>
      <nb-badge status="danger" class="diff-el" text="Template diff" *ngIf="templateDiff && templateModel">
      </nb-badge>
    </div>
    <div>        
        <div *ngFor="let block of _model.blocks; let i = index" class="relative px-3 py-4">
          <div>
            <div *ngIf="block.type == 'dialog'">
              <app-dialog-viewer [model]="block" [languages]="languages" [defaultLang]="defaultLang" [characters]="characters"></app-dialog-viewer>
              <voice-editor *ngIf="game?.ttsVoiceId || template?.ttsVoiceId"
                [game]="game" [template]="template" [missionId]="missionId"
                [model]="block" [languages]="languages" [voices]="voices"
                [characters]="characters"
                (save)="save()"></voice-editor>
            </div>
            <div *ngIf="block.type == 'media'">
              <app-media-viewer [model]="block" [languages]="languages" [defaultLang]="defaultLang"></app-media-viewer>
            </div>
            <div *ngIf="block.type == 'text'">
              <multilang-editor [model]="block.data" [readonly]="true"
                [languages]="languages" [defaultLang]="defaultLang"></multilang-editor>
              <voice-editor *ngIf="game?.ttsVoiceId || template?.ttsVoiceId"
                [game]="game" [template]="template" [missionId]="missionId"
                [model]="block" [languages]="languages" [voices]="voices"
                (save)="save()" ></voice-editor>
            </div>
          </div>
          
          <div class="absolute top-0 right-5" *ngIf="editMode">
            <span class="mr-1">Type: {{block.type}}</span>
            <button nbButton class="mr-1" size="tiny" status="danger" outline (click)="switchElement(block)" *ngIf="block.type == 'dialog'">
              To text
            </button>
            <button nbButton class="mr-1" size="tiny" status="danger" outline (click)="switchElement(block)" *ngIf="block.type == 'text'">
              To dialog
            </button>
            <button nbButton class="mr-1" outline size="tiny" status="info" *ngIf="(_model.blocks.length - 1) !== i" (click)="changePosition(i, i+1)">
              <nb-icon icon="arrow-ios-downward-outline"></nb-icon>
            </button>
            <button nbButton class="mr-1" size="tiny" status="info" *ngIf="i !== 0" outline (click)="changePosition(i, i-1)">
              <nb-icon icon="arrow-ios-upward-outline"></nb-icon>
            </button>
            <button nbButton class="mr-1" size="tiny" status="info" outline (click)="editBlock(i)">
              <nb-icon icon="edit-outline"></nb-icon>
            </button>
            <button nbButton class="mr-1" size="tiny" status="info" outline (click)="duplicateBlock(i)">
              <nb-icon icon="copy-outline"></nb-icon>
            </button>
            <button nbButton size="tiny" status="danger" outline (click)="deleteBlock(i)">
              <nb-icon icon="trash-2-outline"></nb-icon>
            </button>
          </div>
          <!--<div>model:{{_model | json}}</div>-->
        </div>
    </div>
    
    <div *ngIf="editMode">
      <!--<button id="dropdownDefaultButton" data-dropdown-toggle="dropdown" class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2.5 text-center inline-flex items-center" type="button">Add block</button>
      
      <div id="dropdown" class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44">
          <ul class="py-2 text-sm text-gray-700" aria-labelledby="dropdownDefaultButton">
            <li>
              <a href="#" class="block px-4 py-2 hover:bg-gray-100" (click)="addBlock('text')">Text</a>
            </li>
            <li>
              <a href="#" class="block px-4 py-2 hover:bg-gray-100" (click)="addBlock('dialog')">Dialog</a>
            </li>
          </ul>
      </div>-->

      <label class="mb-0">Add new block</label>
      <nb-select [(ngModel)]="newBlockType" class="ml-1 mr-2">
        <nb-option value="text">Text</nb-option>
        <nb-option value="media">Media</nb-option>
        <nb-option value="dialog">Dialog</nb-option>
      </nb-select>
      <button type="button" nbButton size="medium" status="danger" (click)="addBlock(null)">Create</button>
    </div>
  </div>

  <div class="p-3" *ngIf="!isStructuredBlock">
    <multilang-editor [model]="_model" (edit)="editText(null)" 
      [languages]="languages" [defaultLang]="defaultLang"></multilang-editor>
    
    <voice-editor *ngIf="game?.ttsVoiceId || template?.ttsVoiceId"
        [game]="game" [template]="template" [missionId]="missionId"
        [model]="_model" [languages]="languages" [voices]="voices"
        (save)="save()" ></voice-editor>
  </div>

  <!--<div>{{_model | json}}</div>-->

</div>